import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    wrapper: css({
        display: 'flex',
        padding: '30px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '30px',
        alignSelf: 'stretch',
        border: '1px solid rgba(112, 112, 112, 0.50)',
        marginBottom: '10px',

        [theme.breakpoints.down('lg')]: {
            padding: '20px',
            marginBottom: '0px',
        },

        ...(isHosTheme && {
            borderWidth: '0.5px',
            borderColor: theme.palette.secondary.dark,
            borderRadius: theme.custom.borderRadius[23],
            backgroundColor: theme.palette.common.white,
        }),
    }),

    header: css({
        display: 'flex',
        alignItems: 'center',
        gap: '20px',
        alignSelf: 'stretch',
    }),

    title: css({
        display: 'flex',
        paddingTop: '8px',
        flexDirection: 'column',
        alignItems: 'flexStart',
        gap: '10px',
        [theme.breakpoints.down('lg')]: {
            alignItems: 'flex-start',
            gap: '20px',
        },
        ...(isHosTheme && { fontSize: '26px', lineHeight: '30px' }),
    }),

    icon: css({
        width: '24px',
        height: '24px',
        cursor: 'pointer',
    }),

    detailsWrapper: css({
        display: 'flex',
        alignItems: 'flex-start',
        gap: '30px',
        alignSelf: 'stretch',
        flexWrap: 'wrap',
        [theme.breakpoints.down('lg')]: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '10px',
        },
    }),

    subContainer: css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '6px',
        [theme.breakpoints.down('lg')]: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '100%',
        },
    }),

    subContainerHeader: css({
        color: theme.palette.text.secondary,
        [theme.breakpoints.down('lg')]: {
            flex: '1',
            textAlign: 'left',
        },
        ...(isHosTheme && { fontSize: '16px', color: theme.palette.secondary.dark }),
    }),

    subContainerContent: css({
        [theme.breakpoints.down('lg')]: {
            flex: '1',
            textAlign: 'right',
        },
        ...(isHosTheme && {
            fontSize: '16px',
            fontWeight: 500,
            color: theme.palette.primary.main,
            [theme.breakpoints.down('lg')]: {
                fontWeight: 400,
            },
        }),
    }),

    bookingDetailsContainer: {
        padding: '16px',
        paddingTop: '0px',
        ...(isHosTheme && {
            borderColor: theme.palette.secondary.dark,
            backgroundColor: theme.palette.common.white,
            borderRadius: '0 0 23px 23px',
        }),
    },

    detailsRow: {
        display: 'flex',
        justifyContent: 'space-between',
        textTransform: isHosTheme ? 'none' : 'uppercase',
    },

    detailsColumnLeft: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        color: isHosTheme ? theme.palette.secondary.dark : theme.palette.text.secondary,
    },

    detailsColumnRight: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        textAlign: 'right',
        color: isHosTheme ? theme.palette.primary.dark : theme.palette.text.secondary,
    },

    divider: {
        marginBottom: '16px',
    },
};
